import { Star } from 'lucide-react';

export default function StarRating({ value = 0, onChange, readonly = false, size = 'md' }) {
  const stars = [1, 2, 3, 4, 5];

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  const iconSize = sizeClasses[size] || sizeClasses.md;

  return (
    <div className="flex items-center gap-0.5">
      {stars.map((star) => (
        <button
          key={star}
          type="button"
          disabled={readonly}
          onClick={() => !readonly && onChange && onChange(star)}
          className={`focus:outline-none transition-transform ${
            !readonly ? 'cursor-pointer hover:scale-110' : 'cursor-default'
          }`}
          aria-label={`${star} star${star !== 1 ? 's' : ''}`}
        >
          <Star
            className={`${iconSize} ${
              star <= value
                ? 'fill-terra text-terra'
                : 'fill-transparent text-cream-dark stroke-ink-muted'
            } transition-colors`}
          />
        </button>
      ))}
    </div>
  );
}
